<main class="main-grid">
  <div class="activity" *ngIf="!currentActivity">
      <div class="card">
          <div class="activity__container">
              <div class="activity__content">
                  <div class="activity__status">Zakończone</div>
                  <div class="activity__info">Wróć jutro po kolejne zadanie
                      i&nbsp;zdobywaj nagrody!
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div class="activity" *ngIf="currentActivity">
    <div class="card">
      <div class="activity__container">
        <div class="activity__icon anim--{{ currentActivity.iconCss }}">
          <i class="{{ currentActivity.iconCss }} icon-color--{{ currentActivity.defaultColor }}"></i>
        </div>
        <div class="activity__content" (click)="checkActivity_click()">
          <div class="activity__status">Aktywne</div>
          <div class="activity__info">Dzisiejsze zadanie</div>
        </div>
        <div class="activity__arrow">
          <ion-icon name="chevron-forward-outline" class="icon-big color-primary"></ion-icon>
        </div>
      </div>
    </div>
  </div>
</main>
